import Vue from 'vue'

function defaultHttp () {
  return Vue.prototype.$http
}

Vue.prototype.$api = {
  awards () {
    const resource = 'awards'

    return {
      list: (sorts = []) => defaultHttp().get('/api/' + resource + `${sorts.length > 0 ? `?sort=${sorts.join()}` : ''}`),
      listTrashed: () => defaultHttp().get('/api/trashed-' + resource),
      create: (data) => defaultHttp().post('/api/' + resource, data),
      update: (id, data) => defaultHttp().patch('/api/' + resource + '/' + id, data),
      uploadImage: (id, data) => defaultHttp().post('/api/' + resource + '/' + id + '/image', data),
      delete: (id) => defaultHttp().delete('/api/' + resource + '/' + id),
      restore: (id) => defaultHttp().patch('/api/trashed-' + resource + '/' + id),
    }
  },
  persons () {
    const resource = 'persons'

    return {
      show: (id) => defaultHttp().get(`/api/${resource}/${id}`),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
    }
  },
  users () {
    const resource = 'users'

    return {
      list: (param = '') => defaultHttp().get(`/api/${resource}${param}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      show: (id) => defaultHttp().get(`/api/${resource}/${id}`),
      showAuthorized: () => defaultHttp().get('/api/user'),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      updateLastLogin: (data) => defaultHttp().patch(`/api/user-last-login`, data),
    }
  },
  notifications () {
    const resource = 'notifications'

    return {
      list: () => defaultHttp().get(`/api/user/${resource}`),
      update: () => defaultHttp().patch(`/api/user/${resource}`),
    }
  },
  cities () {
    const resource = 'cities'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
    }
  },
  holidays () {
    const resource = 'holidays'
    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
    }
  },
  holidayDetails () {
    const parentResource = 'holidays'
    const resource = 'detail'

    return {
      list: (param) => defaultHttp().get('/api/holiday-details' + param),
      create: (id, data) => defaultHttp().post(`/api/${parentResource}/${id}/${resource}`, data),
      createMany: (data) => defaultHttp().post('/api/holiday-details', data),
      update: (id, data) => defaultHttp().patch(`/api/holiday-details/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/holiday-details/${id}`),
    }
  },
  holidayDetailStates () {
    const parentResource = 'holiday-details'

    return {
      show: (id) => defaultHttp().get(`/api/${parentResource}/${id}/states`),
      update: (id, data) => defaultHttp().put(`/api/${parentResource}/${id}/states`, data),
    }
  },
  departments () {
    const resource = 'departments'

    return {
      list: (sorts = [], withTrashed) => defaultHttp().get(`/api/${resource}${sorts.length > 0 ? `?sort=${sorts.join()}` : ''}${withTrashed ? '?filter[withTrashed]=true' : ''}`),
      listTrashed: () => defaultHttp().get(`/api/trashed-${resource}`),
      show: (id) => defaultHttp().get(`/api/${resource}/${id}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      restore: (id) => defaultHttp().patch(`/api/trashed-${resource}/${id}`),
    }
  },
  employees () {
    const resource = 'employees'

    return {
      list: (param = '') => defaultHttp().get('/api/' + resource + param),
      create: (data) => defaultHttp().post('/api/' + resource, data),
      createEmployeePerson: (data) => defaultHttp().post('/api/employee-persons', data),
      show: (id) => defaultHttp().get('/api/' + resource + '/' + id),
      update: (id, data) => defaultHttp().patch('/api/' + resource + '/' + id, data),
      uploadAvatar: (id, data) => defaultHttp().post(`/api/employees/${id}/avatar`, data),
      overview: (param, data) => defaultHttp().post('/api/employee-overview' + param, data),
      liteOverview: () => defaultHttp().get('/api/employee-lite-overview'),
      updateEmail: (id, data) => defaultHttp().patch(`/api/${resource}/${id}/email`, data),
      updateConfirmedDate: (id, data) => defaultHttp().patch(`/api/${resource}/${id}/confirm-date`, data),
      search: (data) => defaultHttp().post('/api/employee-search', data),
      searchName: (id) => defaultHttp().get(`/api/${resource}/${id}/name`),
    }
  },

  adminStateEmployees () {
    const resource = 'admin-state-employees'

    return {
      list: (param) => defaultHttp().get(`/api/${resource}${param}`),
    }
  },

  employeeTempLeaves () {
    const parentResource = 'employees'
    const childResource = 'temp-leaves'

    return {
      list: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${childResource}`),
      update: (parentId, data) => defaultHttp().put(`/api/${parentResource}/${parentId}/${childResource}`, data),
    }
  },
  employeeAwards () {
    const parentResource = 'employees'
    const resource = 'awards'

    return {
      create: (parentId, data) => defaultHttp().post(`/api/${parentResource}/${parentId}/${resource}`, data),
      show: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${resource}`),
      delete: (parentId, resourceId) => defaultHttp().delete(`/api/${parentResource}/${parentId}/${resource}/${resourceId}`),
    }
  },
  employeeCities () {
    const parentResource = 'employees'
    const resource = 'cities'

    return {
      create: (parentId, data) => defaultHttp().post(`/api/${parentResource}/${parentId}/${resource}`, data),
    }
  },
  employeeWorkdays () {
    const parentResource = 'employees'
    const resource = 'workdays'

    return {
      list: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${resource}`),
      create: (parentId, data) => defaultHttp().post(`/api/${parentResource}/${parentId}/${resource}`, data),
      update: (parentId, data) => defaultHttp().patch(`/api/${parentResource}/${parentId}/${resource}`, data),
    }
  },
  adminStates () {
    const parentResource = 'admins'
    const childResource = 'states'

    return {
      list: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${childResource}`),
      update: (parentId, data) => defaultHttp().put(`/api/${parentResource}/${parentId}/${childResource}`, data),
    }
  },
  leaveEntitlements () {
    const resource = 'leave-entitlements'

    return {
      list: (data) => defaultHttp().post(`/api/${resource}-by-types`, data),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      createMany: () => defaultHttp().post(`/api/${resource}/batch-copy`, ''),
      update: (parentId, data) => defaultHttp().patch(`/api/${resource}/${parentId}`, data),
      destroy: (parentId) => defaultHttp().delete(`/api/${resource}/${parentId}`),
      listEntitlementYear: () => defaultHttp().get('/api/leave-entitlement-years'),
      recalculateProratedDays: (parentId) => defaultHttp().post(`/api/${resource}/recalculate-prorated-days/${parentId}`),
      updateProratedDays: (parentId, data) => defaultHttp().post(`/api/${resource}/update-prorated-days/${parentId}`, data),
      forecastProratedDays: (parentId, data) => defaultHttp().post(`/api/${resource}/forecast-prorated-days/${parentId}`, data),
      updateForecastProratedDays: (parentId, data) => defaultHttp().post(`/api/${resource}/update-forecast-prorated-days/${parentId}`, data),
    }
  },
  leaveTypes () {
    const resource = 'leave-types'

    return {
      list: () => defaultHttp().get('/api/' + resource),
      listTrashed: () => defaultHttp().get(`/api/trashed-${resource}`),
      create: (data) => defaultHttp().post('/api/' + resource, data),
      update: (id, data) => defaultHttp().patch('/api/' + resource + '/' + id, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      restore: (id) => defaultHttp().patch('/api/trashed-' + resource + '/' + id),
    }
  },
  roles (type) {
    const resource = (type === 'hrm' || type === 'workspace') ? 'roles' : `${type}-roles`

    return {
      list: () => defaultHttp().get('/api/' + resource),
      create: (data) => defaultHttp().post('/api/' + resource, data),
      update: (id, data) => defaultHttp().patch('/api/' + resource + '/' + id, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
    }
  },
  permissionGroups (type) {
    const resource = (type === 'hrm' || type === 'workspace') ? 'permission-groups' : `${type}-permission-groups`

    return {
      list: () => defaultHttp().get('/api/' + resource),
    }
  },
  rolePermissions (type) {
    const parentResource = (type === 'hrm' || type === 'workspace') ? 'roles' : `${type}-roles`
    const childResource = 'permissions'

    return {
      list: (id) => defaultHttp().get(`/api/${parentResource}/${id}/${childResource}`),
      update: (id, data) => defaultHttp().put(`/api/${parentResource}/${id}/${childResource}`, data),
    }
  },
  identityCards () {
    const resource = 'identity-cards'
    const childResource = 'identityCards'

    return {
      showPerson: (ic) => defaultHttp().get('/api/' + childResource + '/' + ic + '/person'),
      update: (id, data) => defaultHttp().patch(`/api/persons/${id}/${resource}`, data),
    }
  },
  kpiTarget () {
    return {
      branchOverView: () => defaultHttp().get('/api/branch-kpi-target-overview'),
      employeeOverview: () => defaultHttp().get('/api/kpi-target-overview'),
    }
  },
  kpiCategories () {
    const resource = 'kpi-categories'

    return {
      list: () => defaultHttp().get('/api/' + resource),
      create: (data) => defaultHttp().post('/api/' + resource, data),
      update: (id, data) => defaultHttp().patch('/api/' + resource + '/' + id, data),
      delete: (id) => defaultHttp().delete('/api/' + resource + '/' + id),
    }
  },
  kpiCategoryTypes () {
    const resource = 'kpi-category-types'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
    }
  },
  passwordAttempts () {
    const parentResource = 'users'
    const childResource = 'password-attempts'

    return {
      list: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${childResource}`),
      update: (parentId, data) => defaultHttp().put(`/api/${parentResource}/${parentId}/${childResource}`, data),
    }
  },
  metrics () {
    const resource = 'metrics'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
    }
  },
  lookups () {
    const resource = 'cms-lookups'

    return {
      list: (type = '') => defaultHttp().get('/api/' + resource + '?filter[type]=' + type),
    }
  },
  skillCategories () {
    const resource = 'skill-categories'

    return {
      list: () => defaultHttp().get('/api/' + resource),
      create: (data) => defaultHttp().post('/api/' + resource, data),
      update: (id, data) => defaultHttp().patch('/api/' + resource + '/' + id, data),
      delete: (id) => defaultHttp().delete('/api/' + resource + '/' + id),
    }
  },
  skills () {
    const parentResource = 'skill-categories'
    const resource = 'skills'

    return {
      list: (includes = []) => defaultHttp().get(`/api/${resource}${includes.length > 0 ? `?include=${includes.join()}` : ''}`),
      create: (parentId, data) => defaultHttp().request({
        url: `/api/${parentResource}/${parentId}/${resource}`,
        method: 'post',
        data: data,
        config: {
          headers: { 'Content-Type': 'multipart/form-data' },
        },
      }),
      show: (id) => defaultHttp().get(`/api/${resource}/${id}`),
      update: (id, data) => defaultHttp().patch('/api/' + resource + '/' + id, data),
      uploadImage: (id, data) => defaultHttp().post('/api/' + resource + '/' + id + '/image', data),
      delete: (id) => defaultHttp().delete('/api/' + resource + '/' + id),
    }
  },
  skillLevels () {
    const parentResource = 'skills'
    const resource = 'skill-levels'

    return {
      list: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${resource}`),
      create: (parentId, data) => defaultHttp().post(`/api/${parentResource}/${parentId}/${resource}`, data),
      show: (id) => defaultHttp().get(`/api/${resource}/${id}`),
      update: (parentId, childId, data) => defaultHttp().patch(`/api/${parentResource}/${parentId}/${resource}/${childId}`, data),
    }
  },
  employeeSkills () {
    const parentResource = 'employees'
    const resource = 'skills'

    return {
      list: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${resource}`),
      create: (parentId, data) => defaultHttp().post(`/api/${parentResource}/${parentId}/${resource}`, data),
      update: (parentId, resourceId) => defaultHttp().patch(`/api/${parentResource}/${parentId}/${resource}/${resourceId}`),
      delete: (parentId, resourceId) => defaultHttp().delete(`/api/${parentResource}/${parentId}/${resource}/${resourceId}`),
    }
  },
  companies () {
    const resource = 'companies'

    return {
      list: () => defaultHttp().get('/api/' + resource),
      listAll: () => defaultHttp().get('/api/' + resource + '/listAll'),
    }
  },
  companyBranches () {
    const resource = 'company-branches'

    return {
      list: () => defaultHttp().get('/api/' + resource),
      listNonMLCompanies: () => defaultHttp().get('/api/non-ml-companies'),
    }
  },
  loginPeriods () {
    const parentResource = 'users'
    const childResource = 'login-periods'

    return {
      list: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${childResource}`),
      count: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/login-periods-count`),
      create: (parentId, data) => defaultHttp().post(`/api/${parentResource}/${parentId}/${childResource}`, data),
      update: (parentId, data) => defaultHttp().patch(`/api/${parentResource}/${parentId}/${childResource}`, data),
    }
  },
  userCompanies () {
    const parentResource = 'users'
    const childResource = 'companies'

    return {
      list: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${childResource}`),
      create: (parentId, data) => defaultHttp().post(`/api/${parentResource}/${parentId}/${childResource}`, data),
      update: (parentId, data) => defaultHttp().put(`/api/${parentResource}/${parentId}/${childResource}`, data),
    }
  },
  userBranches () {
    const parentResource = 'users'
    const childResource = 'branches'

    return {
      list: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${childResource}`),
      create: (parentId, data) => defaultHttp().post(`/api/${parentResource}/${parentId}/${childResource}`, data),
      update: (parentId, data) => defaultHttp().put(`/api/${parentResource}/${parentId}/${childResource}`, data),
    }
  },
  userTempBranches () {
    const parentResource = 'users'
    const childResource = 'temp-branches'

    return {
      list: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${childResource}`),
      update: (parentId, data) => defaultHttp().put(`/api/${parentResource}/${parentId}/${childResource}`, data),
    }
  },
  userRoles (type) {
    const parentResource = 'users'
    const childResource = (type !== 'hrm' && type !== 'workspace') ? `${type}-roles` : 'roles'

    return {
      list: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${childResource}`),
      create: (parentId, data) => defaultHttp().post(`/api/${parentResource}/${parentId}/${childResource}`, data),
      update: (parentId, data) => defaultHttp().put(`/api/${parentResource}/${parentId}/${childResource}`, data),
    }
  },
  userTempRoles (type) {
    const parentResource = 'users'
    const childResource = (type !== 'hrm' && type !== 'workspace') ? `temp-${type}-roles` : 'temp-roles'

    return {
      list: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${childResource}`),
      update: (parentId, data) => defaultHttp().put(`/api/${parentResource}/${parentId}/${childResource}`, data),
    }
  },
  approvalLimits () {
    const parentResource = 'users'
    const childResource = 'crm-approval-limits'

    return {
      list: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${childResource}`),
      update: (parentId, data) => defaultHttp().put(`/api/${parentResource}/${parentId}/${childResource}`, data),
    }
  },
  states () {
    const resource = 'states'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
    }
  },
  postcodes () {
    const resource = 'postcodes'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
    }
  },
  branches () {
    const resource = 'branches'
    return {
      overview: (param, data) => defaultHttp().post('/api/branch-overview' + param, data),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      list: (param = '') => defaultHttp().get(`/api/${resource}` + param),
      show: (id) => defaultHttp().get(`/api/${resource}/` + id),
      update: (id, data) => defaultHttp().put(`/api/${resource}/` + id, data),
      internalPromotion: (id, data) => defaultHttp().post(`/api/${resource}/` + id + '/internal-promotion', data),
      externalPromotion: (id, data) => defaultHttp().post(`/api/${resource}/` + id + '/external-promotion', data),
      bicTransfer: (data) => defaultHttp().post('/api/branch-bic-transfer', data),

    }
  },
  userPermissions () {
    return {
      listAuthorized: () => defaultHttp().get('/api/user/permissions'),
      show: (id, name) => defaultHttp().get(`/api/users/${id}/permissions/${name}`),
    }
  },
  reportTo () {
    const parentResource = 'employees'
    const childResource = 'report-to'

    return {
      overview: () => defaultHttp().get(`/api/${childResource}` + '-overview'),
      bulkCreate: (data) => defaultHttp().post(`/api/${parentResource}/${childResource}`, data),
      create: (parentId, data) => defaultHttp().post(`/api/${parentResource}/${parentId}/${childResource}`, data),
      show: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${childResource}`),
    }
  },
  subordinates () {
    const parentResource = 'employees'
    const childResource = 'subordinates'

    return {
      list: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${childResource}`),
      recursiveList: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/recursive-subordinates`),
    }
  },
  superiors () {
    const parentResource = 'employees'
    const childResource = 'superiors'

    return {
      list: (parentId, param) => defaultHttp().get(`/api/${parentResource}/${parentId}/${childResource}${param}`),
    }
  },
  promises () {
    const parentResource = 'employees'
    const childResource = 'promises'

    return {
      list: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${childResource}`),
      listOwned: (param) => defaultHttp().get(`/api/owned-promises${param}`),
      create: (data) => defaultHttp().post(`/api/${childResource}`, data),
      update: (childId, data) => defaultHttp().put(`/api/${childResource}/${childId}`, data),
      cancel: (childId) => defaultHttp().put(`/api/${childResource}/${childId}/cancel`),
      pendingCount: () => defaultHttp().get('/api/owned-promises/pending-count'),
    }
  },
  ranks () {
    const resource = 'ranks'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      create: (data) => defaultHttp().request({
        url: `/api/${resource}`,
        method: 'post',
        data: data,
        config: {
          headers: { 'Content-Type': 'multipart/form-data' },
        },
      }),
      uploadImage: (id, data) => defaultHttp().post(`/api/${resource}/${id}/image`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
    }
  },
  positionLeaveApprovalLevels () {
    const parentResource = 'positions'
    const resource = 'leave-approval-levels'

    return {
      list: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${resource}`),
      update: (parentId, data) => defaultHttp().put(`/api/${parentResource}/${parentId}/${resource}`, data),
    }
  },
  positionLeaveApprovalAuthorities () {
    const parentResource = 'positions'
    const resource = 'leave-approval-authorities'

    return {
      list: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${resource}`),
      update: (parentId, data) => defaultHttp().put(`/api/${parentResource}/${parentId}/${resource}`, data),
    }
  },
  leaveTypeApprovalLevels () {
    const parentResource = 'leave-types'
    const resource = 'approval-levels'

    return {
      update: (parentId, data) => defaultHttp().put(`/api/${parentResource}/${parentId}/${resource}`, data),
    }
  },
  leaveTypeApprovalAuthorities () {
    const parentResource = 'leave-types'
    const resource = 'approval-authorities'

    return {
      update: (parentId, data) => defaultHttp().put(`/api/${parentResource}/${parentId}/${resource}`, data),
    }
  },
  positions () {
    const resource = 'positions'

    return {
      list: (withTrashed = false) => defaultHttp().get(`/api/${resource}${withTrashed ? '?filter[withTrashed]=true' : ''}`),
      listTrashed: () => defaultHttp().get(`/api/trashed-${resource}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      restore: (id) => defaultHttp().patch(`/api/trashed-${resource}/${id}`),
    }
  },
  employeePositions () {
    const parentResource = 'employees'
    const childResource = 'positions'
    const singleChildResource = 'position'
    const resource = 'employee-positions'

    return {
      list: (id) => defaultHttp().get(`/api/${parentResource}/${id}/${childResource}`),
      create: (parentId, data) => defaultHttp().request({
        url: `/api/${parentResource}/${parentId}/${childResource}`,
        method: 'post',
        data: data,
        config: {
          headers: { 'Content-Type': 'multipart/form-data' },
        },
      }),
      upload: (id, data) => defaultHttp().request({
        url: `/api/${resource}/${id}/documents`,
        method: 'post',
        data: data,
        config: {
          headers: { 'Content-Type': 'multipart/form-data' },
        },
      }),
      show: (id) => defaultHttp().get(`/api/${parentResource}/${id}/${singleChildResource}`),
    }
  },
  tags () {
    const resource = 'tags'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
    }
  },
  jobDescriptions () {
    const resource = 'job-descriptions'

    return {
      list: (includes = []) => defaultHttp().get(`/api/${resource}${includes.length > 0 ? `?include=${includes.join()}` : ''}`),
      show: (id) => defaultHttp().get(`/api/${resource}/${id}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
    }
  },
  jobDescriptionTags () {
    const parentResource = 'job-descriptions'
    const resource = 'tags'

    return {
      list: (id) => defaultHttp().get(`/api/${parentResource}/${id}/${resource}`),
      update: (id, data) => defaultHttp().put(`/api/${parentResource}/${id}/${resource}`, data),
    }
  },
  jobRequirements () {
    const parentResource = 'job-descriptions'
    const resource = 'skills'

    return {
      list: (id) => defaultHttp().get(`/api/${parentResource}/${id}/${resource}`),
      create: (id, data) => defaultHttp().post(`/api/${parentResource}/${id}/${resource}`, data),
      delete: (id, childId) => defaultHttp().delete(`/api/${parentResource}/${id}/${resource}/${childId}`),
    }
  },
  incidentTypes () {
    const resource = 'incident-types'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
    }
  },
  incidents () {
    const parentResource = 'employees'
    const childResource = 'incidents'

    return {
      list: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${childResource}`),
      create: (parentId, data) => defaultHttp().request({
        url: `/api/${parentResource}/${parentId}/${childResource}`,
        method: 'post',
        data: data,
        config: {
          headers: { 'Content-Type': 'multipart/form-data' },
        },
      }),
      upload: (childId, data) => defaultHttp().request({
        url: `/api/${childResource}/${childId}/documents`,
        method: 'post',
        data: data,
        config: {
          headers: { 'Content-Type': 'multipart/form-data' },
        },
      }),
      update: (parentId, childId, data) => defaultHttp().patch(`/api/${parentResource}/${parentId}/${childResource}/${childId}`, data),
      delete: (parentId, childId) => defaultHttp().delete(`/api/${parentResource}/${parentId}/${childResource}/${childId}`),
    }
  },
  leaveSessions () {
    let resource = 'leave-sessions'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
    }
  },
  candidates () {
    const resource = 'candidates'

    return {
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      show: (id) => defaultHttp().get(`/api/${resource}/${id}`),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
    }
  },
  jobReferralSources () {
    const resource = 'job-referral-sources'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
    }
  },
  jobApplications () {
    const parentResource = 'persons'
    const childResource = 'job-applications'
    const subResource = 'documents'

    return {
      list: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${childResource}`),
      create: (parentId, data) => defaultHttp().request({
        url: `/api/${parentResource}/${parentId}/${childResource}`,
        method: 'post',
        data: data,
        config: {
          headers: { 'Content-Type': 'multipart/form-data' },
        },
      }),
      upload: (childId, data) => defaultHttp().request({
        url: `/api/${childResource}/${childId}/${subResource}`,
        method: 'post',
        data: data,
        config: {
          headers: { 'Content-Type': 'multipart/form-data' },
        },
      }),
    }
  },
  separationTypes () {
    const resource = 'separation-types'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
    }
  },
  employeeSeparations () {
    const parentResource = 'employees'
    const childResource = 'separations'
    const subResource = 'documents'

    return {
      list: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${childResource}`),
      create: (parentId, data) => defaultHttp().request({
        url: `/api/${parentResource}/${parentId}/${childResource}`,
        method: 'post',
        data: data,
        config: {
          headers: { 'Content-Type': 'multipart/form-data' },
        },
      }),
      update: (parentId, childId, data) => defaultHttp().patch(`/api/${parentResource}/${parentId}/${childResource}/${childId}`, data),
      upload: (childId, data) => defaultHttp().request({
        url: `/api/${childResource}/${childId}/${subResource}`,
        method: 'post',
        data: data,
        config: {
          headers: { 'Content-Type': 'multipart/form-data' },
        },
      }),
    }
  },
  myLeaveEntitlements () {
    const parentResource = 'me'
    const childResource = 'leave-entitlements'

    return {
      list: () => defaultHttp().get(`/api/${parentResource}/${childResource}`),
    }
  },
  leaveApplications () {
    const parentResource = 'employees'
    const secondParentResource = 'leave-entitlements'
    const childResource = 'leave-applications'

    return {
      list: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${childResource}`),
      create: (secondParentId, data) => defaultHttp().post(`/api/${secondParentResource}/${secondParentId}/${childResource}`, data),
      cancel: (childId) => defaultHttp().post(`/api/${childResource}/${childId}/cancel`),
    }
  },
  coworkerWithLeaves () {
    const parentResource = 'employees'
    const childResource = 'coworkers-leaves'

    return {
      list: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${childResource}`),
    }
  },
  subordinateWithLeaves () {
    const parentResource = 'employee'
    const childResource = 'subordinates-leaves'

    return {
      list: () => defaultHttp().get(`/api/${parentResource}/${childResource}`),
    }
  },
  leaveRequestApprovals () {
    const parentResource = 'leave-approval-requests'
    const childResource = 'leave-approvals'

    return {
      list: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${childResource}`),
    }
  },
  leaveApprovals () {
    const resource = 'leave-approvals'

    return {
      approve: (childId, data) => defaultHttp().patch(`/api/${resource}/${childId}/approve`, data),
      reject: (childId, data) => defaultHttp().patch(`/api/${resource}/${childId}/reject`, data),
    }
  },
  employeeLeaveApprovals () {
    const parentResource = 'employees'
    const childResource = 'leave-approvals'

    return {
      list: (parentId, param, id) => defaultHttp().get(`/api/${parentResource}/${parentId}/${childResource}/${id}` + param),
      search: (status, data) => defaultHttp().post(`/api/${childResource}/${status}`, data),
    }
  },
  approvalStatus () {
    const resource = 'approval-status'

    return {
      list: (id) => defaultHttp().get(`/api/${resource}`),
    }
  },
  assigneeTasks () {
    const parentResource = 'tasks'

    return {
      list: (parentId, param, data) => defaultHttp().post(`/api/assignees/${parentId}/tasks` + param, data),
      create: (data) => defaultHttp().post(`/api/create-on-behalf/${parentResource}`, data),
      complete: (parentId, data) => defaultHttp().patch(`/api/${parentResource}/${parentId}/complete`, data),
      update: (data) => defaultHttp().patch('/api/assignee-rate', data),
      pendingTaskCount: (parentId) => defaultHttp().get(`/api/assignees/${parentId}/assignee-tasks/pending-count`),
    }
  },

  ownerTasks () {
    const parentResource = 'tasks'

    return {
      list: (parentId, param, data) => defaultHttp().post(`/api/owners/${parentId}/tasks` + param, data),
      create: (data) => defaultHttp().post(`/api/${parentResource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${parentResource}/${id}`, data),
      cancel: (parentId, data) => defaultHttp().patch(`/api/${parentResource}/${parentId}/cancel`, data),
      approve: (parentId, data) => defaultHttp().patch(`/api/${parentResource}/${parentId}/approve`, data),
      revert: (parentId, data) => defaultHttp().patch(`/api/${parentResource}/${parentId}/revert`, data),
      pendingTaskCount: (parentId) => defaultHttp().get(`/api/owners/${parentId}/owner-tasks/pending-count`),
      completedTaskCount: (parentId) => defaultHttp().get(`/api/owners/${parentId}/owner-tasks/completed-count`),
    }
  },

  viewerTasks () {
    const parentResource = 'tasks'

    return {
      list: (parentId, param, data) => defaultHttp().post(`/api/viewers/${parentId}/${parentResource}` + param, data),
    }
  },

  taskDocuments () {
    const parentResource = 'tasks'
    const childResource = 'document'

    return {
      create: (id, data) => defaultHttp().post(`/api/${parentResource}/${id}/${childResource}`, data),
    }
  },

  taskComments () {
    const parentResource = 'tasks'
    const childResource = 'comment'

    return {
      create: (id, data) => defaultHttp().post(`/api/${parentResource}/${id}/${childResource}`, data),
    }
  },

  allTasks () {
    const resource = 'all-tasks'

    return {
      list: (param, data) => defaultHttp().post(`/api/${resource}` + param, data),
    }
  },

  classroomTypes () {
    const resource = 'classroom-types'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      listTrashed: () => defaultHttp().get(`/api/trashed-${resource}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      restore: (id) => defaultHttp().patch(`/api/trashed-${resource}/${id}`),
    }
  },

  courseCategories () {
    const resource = 'course-categories'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      listTrashed: () => defaultHttp().get(`/api/trashed-${resource}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      restore: (id) => defaultHttp().patch(`/api/trashed-${resource}/${id}`),
    }
  },

  courses () {
    const resource = 'courses'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().post(`/api/${resource}/${id}`, data),
      show: (id) => defaultHttp().get(`/api/${resource}/${id}`),
      listCourseDetails: (id) => defaultHttp().get(`/api/${resource}/${id}/details`),
    }
  },

  courseMaterialTypes () {
    const resource = 'course-material-types'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      listTrashed: () => defaultHttp().get(`/api/trashed-${resource}`),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      restore: (id) => defaultHttp().patch(`/api/trashed-${resource}/${id}`),
    }
  },

  courseMaterials () {
    const parentResource = 'courses'
    const childResource = 'course-materials'

    return {
      show: (id) => defaultHttp().get(`/api/${childResource}/${id}`),
      delete: (id) => defaultHttp().delete(`/api/${childResource}/${id}`),
      restore: (id) => defaultHttp().patch(`/api/trashed-${childResource}/${id}`),
      listTrashed: () => defaultHttp().get(`/api/trashed-${childResource}`),
      create: (parentId, data) => defaultHttp().post(`/api/${parentResource}/${parentId}/${childResource}`, data),
      update: (id, data) => defaultHttp().post(`/api/${childResource}/${id}`, data),
    }
  },

  courseMaterialDocuments () {
    const parentResource = 'course-materials'
    const childResource = 'documents'

    return {
      delete: (parentId, childId, data) => defaultHttp().delete(`/api/${parentResource}/${parentId}/${childResource}/${childId}`, data),
    }
  },

  courseMaterialLinks () {
    const parentResource = 'course-materials'
    const childResource = 'links'

    return {
      delete: (parentId, childId, data) => defaultHttp().delete(`/api/${parentResource}/${parentId}/${childResource}/${childId}`, data),
    }
  },

  trainingSessions () {
    const parentResource = 'courses'
    const resource = 'training-sessions'

    return {
      list: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${resource}`),
      show: (id) => defaultHttp().get(`/api/${resource}/${id}`),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
    }
  },

  trainingParticipants () {
    const parentResource = 'training-sessions'
    const childResource = 'participants'

    return {
      list: (Id) => defaultHttp().get(`/api/${parentResource}/${Id}/${childResource}`),
      update: (parentId, data) => defaultHttp().put(`/api/${parentResource}/${parentId}/${childResource}`, data),
      attendance: (parentId, data) => defaultHttp().patch(`/api/${parentResource}/${parentId}/${childResource}/attendance`, data),
      revertAttendance: (parentId, data) => defaultHttp().patch(`/api/${parentResource}/${parentId}/${childResource}/revert-attendance`, data),
      delete: (parentId, data) => defaultHttp().patch(`/api/${parentResource}/${parentId}/${childResource}/remove`, data),
      search: (data) => defaultHttp().post('/api/participant-training', data),
    }
  },

  participantCourses () {
    const resource = 'my-courses'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
    }
  },

  trainingSessionInstructors () {
    const resource = 'training-instructors'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
    }
  },

  trainingSessionModerators () {
    const resource = 'training-moderators'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
    }
  },

  timeClocks () {
    const parentResource = 'employees'
    const childResource = 'time-clocks'

    return {
      list: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${childResource}`),
      create: (parentId, data) => defaultHttp().post(`/api/${parentResource}/${parentId}/${childResource}`, data),
      show: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${childResource}/latest`),
      update: (id, data) => defaultHttp().patch(`/api/${childResource}/${id}`, data),
    }
  },

  notificationTypes () {
    const resource = 'notification-types'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      listTrashed: () => defaultHttp().get(`/api/trashed-${resource}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      restore: (id) => defaultHttp().patch(`/api/trashed-${resource}/${id}`),
    }
  },

  employeeNotifications () {
    const parentResource = 'employees'
    const childResource = 'notifications'

    return {
      list: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${childResource}`),
      update: (parentId, data) => defaultHttp().put(`/api/${parentResource}/${parentId}/${childResource}`, data),
    }
  },

  taskPriorities () {
    const resource = 'task-priorities'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      listTrashed: () => defaultHttp().get(`/api/trashed-${resource}`),
      show: (id) => defaultHttp().get(`/api/${resource}/${id}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      restore: (id) => defaultHttp().patch(`/api/trashed-${resource}/${id}`),
    }
  },

  taskCategories () {
    const resource = 'task-categories'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      listTrashed: () => defaultHttp().get(`/api/trashed-${resource}`),
      show: (id) => defaultHttp().get(`/api/${resource}/${id}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      restore: (id) => defaultHttp().patch(`/api/trashed-${resource}/${id}`),
    }
  },

  leaveEntitlementSettings () {
    const resource = 'leave-entitlement-settings'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      listTrashed: () => defaultHttp().get(`/api/trashed-${resource}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      restore: (id) => defaultHttp().patch(`/api/trashed-${resource}/${id}`),
    }
  },

  leaveEntitlementSettingDetails () {
    const resource = 'leave-entitlement-setting-details'

    return {
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (parentId, data) => defaultHttp().patch(`/api/leave-entitlement-settings/${parentId}/${resource}`, data),
    }
  },

  employeeLeaveEntitlementSettings () {
    const resource = 'employees'
    const childResource = 'leave-entitlement-settings'

    return {
      list: (id) => defaultHttp().get(`/api/${resource}/${id}/${childResource}`),
    }
  },

  exams () {
    const parentResource = 'courses'
    const childResource = 'exams'

    return {
      list: (id) => defaultHttp().get(`/api/${parentResource}/${id}/${childResource}`),
      create: (id, data) => defaultHttp().post(`/api/${parentResource}/${id}/${childResource}`, data),
      update: (id, data) => defaultHttp().put(`/api/${childResource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${childResource}/${id}`),
    }
  },

  questionTypes () {
    const resource = 'question-types'

    return {
      list: (id) => defaultHttp().get(`/api/${resource}`),
    }
  },

  examQuestions () {
    const parentResource = 'exams'
    const childResource = 'exam-questions'

    return {
      list: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${childResource}`),
      create: (parentId, data) => defaultHttp().post(`/api/${parentResource}/${parentId}/${childResource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${childResource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${childResource}/${id}`),
    }
  },

  examAttempts () {
    const parentResource = 'exams'
    const resource = 'exam-attempts'

    return {
      list: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${resource}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
    }
  },
  participantExamQuestions () {
    const parentResource = 'exams'
    const childResource = 'participant-exam-questions'

    return {
      list: (parentId, param) => defaultHttp().get(`/api/${parentResource}/${parentId}/${childResource}` + param),
    }
  },

  examAttemptAnswers () {
    const parentResource = 'exam-attempts'
    const secondParentResource = 'exam-questions'
    const childResource = 'exam-attempt-answers'

    return {
      list: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${childResource}`),
      create: (parentId, secondParentId, data) => defaultHttp().post(`/api/${parentResource}/${parentId}/${secondParentResource}/${secondParentId}/${childResource}`, data),
      update: (parentId, data) => defaultHttp().patch(`/api/${parentResource}/${parentId}/${childResource}`, data),
    }
  },

  courseParticipants () {
    const parentResource = 'courses'
    const childResource = 'course-participants'

    return {
      list: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${childResource}`),
    }
  },

  examParticipants () {
    const parentResource = 'exams'
    const childResource = 'exam-participants'

    return {
      list: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${childResource}`),
      create: (parentId, data) => defaultHttp().post(`/api/${parentResource}/${parentId}/${childResource}`, data),
      bulkDelete: (parentId, data) => defaultHttp().delete(`/api/${parentResource}/${parentId}/${childResource}`, { data }),
    }
  },

  myExams () {
    const parentResource = 'courses'
    const resource = 'my-exams'

    return {
      list: (parentId) => defaultHttp().get(`/api/${parentResource}/${parentId}/${resource}`),
    }
  },

  leaveReports () {
    return {
      generateRemainingLeaveBalance: (data) => defaultHttp().post(`/api/remaining-leave-balance-report`, data, { responseType: 'blob' }),
      approvedLeaveYears: () => defaultHttp().get(`/api/approved-leave-years`),
      generateApprovedLeaveReport: (data) => defaultHttp().post(`/api/approved-leave-report`, data, { responseType: 'blob' }),
      subordinateRemainingLeaveBalance: (data) => defaultHttp().post(`/api/subordinate-remaining-leave-balance`, data, { responseType: 'blob' }),
      subordinateLeaveYears: () => defaultHttp().get(`/api/subordinates-remaining-leave-balance-years`),
    }
  },

  employeeAttendanceSettings () {
    const parentResource = 'employees'
    const resource = 'attendance-settings'

    return {
      update: (parentId, data) => defaultHttp().patch(`/api/${parentResource}/${parentId}/${resource}`, data),
      bulkUpdate: (data) => defaultHttp().patch('/api/attendance-settings-bulk', data),
    }
  },

  officeLocations () {
    const resource = 'office-locations'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
    }
  },

  workSessionTypes () {
    let resource = 'work-session-types'

    return {
      list: (param) => defaultHttp().get(`/api/${resource}${param}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().put(`/api/${resource}/${id}`, data),
    }
  },

  employeeClockInSessions () {
    let resource = 'clock-in-session-years'
    let childResource = 'clock-in-session-months'

    return {
      listClockInSessionYear: () => defaultHttp().get(`/api/${resource}`),
      listClockInSessionDate: () => defaultHttp().get(`/api/${childResource}`),
    }
  },

  reports () {
    let resource = 'report-attendance'

    return {
      generateAttendanceReport: (data) => defaultHttp().post(`/api/${resource}`, data),
    }
  },
  genders () {
    let resource = 'genders'
    return {
      list: () => defaultHttp().get(`/api/${resource}`),
    }
  },

  educationLevels () {
    let resource = 'education-levels'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
    }
  },

  maritalStatuses () {
    let resource = 'marital-statuses'
    return {
      list: () => defaultHttp().get(`/api/${resource}`),
    }
  },

  relationships () {
    let resource = 'relationships'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
    }
  },
  
  familyMembers () {
    let resource = 'employees'
    let childResource = 'family-members'

    return {
      list: (parentId) => defaultHttp().get(`/api/${resource}/${parentId}/${childResource}`),
      create: (parentId, data) => defaultHttp().post(`/api/${resource}/${parentId}/${childResource}`, data),
      update: (id, data) => defaultHttp().put(`/api/${childResource}/${id}`, data),
      destroy: (id) => defaultHttp().delete(`/api/${childResource}/${id}`),
    }
  },

  announcements () {
    let resource = 'announcements'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().post(`/api/${resource}/${id}`, data),
      show: (id) => defaultHttp().get(`/api/${resource}/${id}`, id),
      publish: (id, data) => defaultHttp().patch(`/api/${resource}/${id}/publish`, data),
    }
  },

  announcementDocuments () {
    let resource = 'announcement-documents'

    return {
      destroy: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      show: (id) => defaultHttp().get(`/api/${resource}/${id}`, { responseType: 'blob' }),
    }
  },
  
  announcementLinks () {
    let resource = 'announcement-links'

    return {
      destroy: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
    }
  },
  
  employeeAnnouncements () {
    let resource = 'employee-announcements'

    return {
      list: (isRead) => defaultHttp().get(`/api/${resource}/${isRead}`),
      markAsRead: (id) => defaultHttp().patch(`/api/${resource}/${id}`),
    }
  },

  leaveEntitlementAdjustments () {
    const resource = 'leave-entitlement-adjustments'

    return {
      create: (data) => defaultHttp().request({
        url: `/api/${resource}`,
        method: 'post',
        data: data,
        config: {
          headers: { 'Content-Type': 'multipart/form-data' },
        },
      }),
      show: (id) => defaultHttp().get(`/api/${resource}/${id}`),
    }
  },

  announcementCategories () {
    let resource = 'announcement-categories'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      listTrashed: () => defaultHttp().get(`/api/trashed-${resource}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      restore: (id) => defaultHttp().patch(`/api/trashed-${resource}/${id}`),
    }
  },

  jobBands () {
    let resource = 'job-bands'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      listTrashed: () => defaultHttp().get(`/api/trashed-${resource}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      restore: (id) => defaultHttp().patch(`/api/trashed-${resource}/${id}`),
      uploadImage: (id, data) => defaultHttp().post(`/api/${resource}/${id}/image`, data),
    }
  },

  jobCategories () {
    let resource = 'job-categories'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      listTrashed: () => defaultHttp().get(`/api/trashed-${resource}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      restore: (id) => defaultHttp().patch(`/api/trashed-${resource}/${id}`),
    }
  },

  jobGroups () {
    let resource = 'job-groups'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      listTrashed: () => defaultHttp().get(`/api/trashed-${resource}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      restore: (id) => defaultHttp().patch(`/api/trashed-${resource}/${id}`),
    }
  },
  
  jobGrades () {
    let resource = 'job-grades'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      listTrashed: () => defaultHttp().get(`/api/trashed-${resource}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      restore: (id) => defaultHttp().patch(`/api/trashed-${resource}/${id}`),
    }
  },

  documents () {
    let resource = 'file-managers'
    let childResource = 'document'

    return {
      list: (id) => defaultHttp().get(`/api/${resource}/${id}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      upload: (data) => defaultHttp().post(`/api/${resource}/${childResource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete('/api/' + resource + '/' + id),
    }
  },

  entitlementLeaveApplications () {
    const parentResource = 'leave-entitlements'
    const childResource = 'leave-applications'

    return {
      list: (parentId) => defaultHttp().get(`/api/hr/${parentResource}/${parentId}/${childResource}`),
      cancel: (childId, data) => defaultHttp().post(`/api/hr/${parentResource}/${childResource}/${childId}/cancel`, data),
    }
  },
  
  attendances () {
    const resource = 'attendance-imports'

    return {
      import: (data) => defaultHttp().post(`/api/${resource}`, data),
      sync: (data) => defaultHttp().post(`/api/${resource}/sync`, data),
      export: (data) => defaultHttp().post(`/api/attendances/export`, data, { responseType: 'blob' }),
      list: () => defaultHttp().get(`/api/all/attendances/month`),
      delete: (id) => defaultHttp().delete(`/api/attendances/${id}`),
    }
  },

  myAttendances () {
    const parentResource = 'me'
    const childResource = 'attendances'

    return {
      download: (data) => defaultHttp().post(`/api/${parentResource}/${childResource}/download`, data, { responseType: 'blob' }),
    }
  },

  qualityManagementFolders () {
    let resource = 'quality-management-folders'
    
    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      listTrashed: () => defaultHttp().get(`/api/trashed-${resource}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      restore: (id) => defaultHttp().patch(`/api/trashed-${resource}/${id}`),
    }
  },

  qualityManagement () {
    let resource = 'quality-managements'

    return {
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      list: (id) => defaultHttp().get(`/api/${resource}`),
      update: (id, data) => defaultHttp().patch(`/api/${resource}/${id}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
    }
  },

  myQualityManagement () {
    let resource = 'my-quality-managements'
    let childResource = 'document'

    return {
      list: (id) => defaultHttp().get(`/api/${resource}/${id}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      delete: (id) => defaultHttp().delete(`/api/${resource}/${id}`),
      upload: (data) => defaultHttp().post(`/api/${resource}/${childResource}`, data),
    }
  },

  qualityManagementDocuments () {
    let resource = 'quality-management-documents'

    return {
      show: (id) => defaultHttp().get(`/api/${resource}/${id}`, { responseType: 'blob' }),
    }
  },

  events () {
    let resource = 'events'

    return {
      list: () => defaultHttp().get(`/api/${resource}`),
      create: (data) => defaultHttp().post(`/api/${resource}`, data),
      update: (id, data) => defaultHttp().post(`/api/${resource}/${id}`, data),
    }
  },
}
